import { render } from "./ViewInserts.vue?vue&type=template&id=e5b70838&scoped=true"
import script from "./ViewInserts.vue?vue&type=script&lang=js"
export * from "./ViewInserts.vue?vue&type=script&lang=js"

import "./ViewInserts.vue?vue&type=style&index=0&id=e5b70838&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5b70838"]])

export default __exports__